<template>
  <v-sheet>
    <v-tabs v-model="tab">
      <v-tabs-slider color="accent" />
      <v-tab
        key="tab-item-0"
      >
        General
      </v-tab>
      <v-tab
        key="tab-item-1"
      >
        Regions
      </v-tab>
      <v-tab
        key="tab-item-2"
      >
        F5 NICs
      </v-tab>
      <v-tab
        key="tab-item-3"
      >
        Permissions
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab"
    >
      <v-tab-item
        key="tab-item-0"
      >
        <settings-tab />
      </v-tab-item>
      <v-tab-item
        key="tab-item-1"
      >
        <items-tab 
          :itemProps="regionProps"
        />
      </v-tab-item>
      <v-tab-item
        key="tab-item-2"
      >
        <items-tab 
          :itemProps="f5Props"
        />
      </v-tab-item>
      <v-tab-item
        key="tab-item-3"
      >
        <items-tab 
          :itemProps="permissionLevelProps"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-sheet>
</template>
<script>
  export default {
    name: 'AdminTabs',
      data () {
        return {
          tab: 0,
          regionProps: {
            headers: [
              { text: 'Name', value: 'region_name' },
              { text: 'Code', value: 'region_short' },
              { text: 'IP Prefix', value: 'region_ip' },
              { text: 'DR Pair', value: 'dr_region_id' },
              { text: 'Disable Alerts', value: 'disable_alerts'},
              { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedItem: {
              region_name: '',
              region_short: '',
              region_ip: '',
              disable_alerts: 'n',
              dr_region_id: null
            },
            defaultItem: {
              region_name: '',
              region_short: '',
              region_ip: '',
              disable_alerts: 'n',
              dr_region_id: null
            },
            itemsDispatch: 'settings/load_regions',
            itemsGetter: 'settings/regions',
            title: 'Region',
            toolbarTitle: 'Regions',
            apiUrl: '/v2/regions/',
            uniqueId: 'region_id'
          },
          f5Props: {
            headers: [
              { text: 'Name', value: 'f5_nic_name' },
              { text: 'Private IP', value: 'private_ip_address' },
              { text: 'Public IP', value: 'public_ip_address' },
              { text: 'Region', value: 'region_id' },
              { text: 'RDS Server', value: 'rds_server' },
              { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedItem: {
              f5_nic_name: '',
              private_ip_address: '',
              public_ip_address: '',
              region_id: '',
              rds_server: 'n',
            },
            defaultItem: {
              f5_nic_name: '',
              private_ip_address: '',
              public_ip_address: '',
              region_id: '',
              rds_server: 'n',
            },
            itemsDispatch: 'settings/load_f5_nics',
            itemsGetter: 'settings/f5_nics',
            title: 'F5 NIC',
            toolbarTitle: 'F5 NICs',
            apiUrl: '/v2/f5_nic/',
            uniqueId: 'f5_nic_id'
          },
          permissionLevelProps: {
            headers: [
              { text: 'Name', value: 'name' },
              { text: 'Description', value: 'description' },
              { text: 'Title', value: 'title' },
              { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedItem: {
              name: '',
              description: '',
              title: '',
            },
            defaultItem: {
              name: '',
              description: '',
              title: '',
            },
            itemsDispatch: 'settings/load_permission_levels',
            itemsGetter: 'settings/permission_levels',
            title: 'Permission',
            toolbarTitle: 'Permission Levels',
            apiUrl: '/v2/permissions/',
            uniqueId: 'permission_id'
          }
        }
      }
  }
</script>